module.exports = __webpack_public_path__ + "img/search.8ab80662.svg";